export enum Fossa {
  SEPTICA = 'SEPTICA',
  NEGRA = 'NEGRA',
  LANCAMENTO_DIRETO = 'LANCAMENTO_DIRETO',
}
